<template>
  <div class="spaced-row">
    <div class="flex-spacer"></div>

    <mad-select v-model="selectedRange" class="_chart-select" :options="rangeOptions" />

    <mad-select
      v-if="selectedRange === 'month'"
      v-model="selectedMonth"
      class="_chart-select"
      :options="monthOptions"
    />

    <mad-select
      v-if="selectedRange === 'year'"
      v-model="selectedYear"
      class="_chart-select"
      :options="yearOptions"
    />

    <div v-if="selectedRange === 'custom'">
      <div class="spaced-row">
        <label>Start date</label>
        <mad-input-date v-model="selectedCustom.start" class="_chart-select" />
        <label>End date</label>
        <mad-input-date v-model="selectedCustom.end" class="_chart-select" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  format, startOfMonth, subMonths, subDays,
  startOfYear,
  endOfYear,
  differenceInCalendarDays,
} from 'date-fns'

export default {
  data() {
    const startMonth = startOfMonth(new Date())
    const monthOptions = [...Array(24)].map((_, i) => ({
      value: {
        start: new Date(subMonths(startMonth, i)),
        end: new Date(subDays(subMonths(startMonth, i - 1), 1)),
      },
      label: format(subMonths(startMonth, i), 'MMMM YYYY'),
    }))
    const year = new Date().getFullYear()
    const yearOptions = [...Array(5)].map((_, i) => ({
      value: {
        start: new Date(year - i, 0, 1),
        end: subDays(new Date(year - i + 1, 0, 1), 1),
      },
      label: year - i,
    }))

    const rangeOptions = [
      { value: 'month', label: 'Month' },
      { value: 'year', label: 'Year' },
      { value: 'custom', label: 'Custom range' },
    ]

    return {
      selectedRange: 'month',
      rangeOptions,
      selectedYear: yearOptions[0].value,
      yearOptions,
      selectedMonth: monthOptions[0].value,
      monthOptions,
      selectedCustom: {
        start: subMonths(new Date(), 1),
        end: subMonths(new Date(), 0),
      },
    }
  },

  computed: {
    selectedPeriod() {
      let startEnd = null
      if (this.selectedRange === 'year') {
        startEnd = this.selectedYear
      } else if (this.selectedRange === 'month') {
        startEnd = this.selectedMonth
      } else {
        if (this.selectedCustom.start > this.selectedCustom.end) {
          return this.$mad.message.error('End date may not preceed start date')
        }
        startEnd = {
          start: this.selectedCustom.start,
          // the end is inclusive
          end: this.selectedCustom.end,
        }
      }
      const period = { ...startEnd, range: this.selectedRange }

      const previousPeriod = this.previousPeriod(period)

      // TODO: It's probably possible to rewrite this into better readable code
      return { ...period, ...previousPeriod }
    },
  },

  watch: {
    selectedPeriod: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit('changes', this.selectedPeriod)
      },
    },
  },

  methods: {

    previousPeriod(period) {
      if (period.range === 'month') {
        const previousStart = subMonths(new Date(period.start), 1)
        const previousEnd = subMonths(new Date(period.end), 1)
        return {
          previousStart,
          previousEnd,
        }
      }
      if (period.range === 'year') {
        const previousStart = startOfYear(subDays(new Date(period.start), 1))
        const previousEnd = endOfYear(previousStart)
        return {
          previousStart,
          previousEnd,
        }
      }
      if (period.range === 'custom') {
        const customPeriod = differenceInCalendarDays(
          period.end,
          period.start,
        )

        const previousStart = subDays(new Date(period.start), customPeriod)
        const previousEnd = subDays(new Date(period.start), 1)
        return {
          previousStart,
          previousEnd,
        }
      }
    },
  },
}
</script>

<style scoped>
._chart-select {
  width: 140px;
}
</style>
